export function setReviews(state, data) {
    if (data) {
        state.reviews = {
            ...state.reviews,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
        };
    }
}


export function setUser(state, data) {
    state.user.data = data;
}


export function setToken(state, token) {
    state.user.token = token;
    if (token) {
        localStorage.setItem("TOKEN", token);
    } else {
        localStorage.removeItem("TOKEN");
    }
}

export function setNotifications(state, [data, loading]) {
    state.notifications.data = data.data
    state.notifications.loading = loading
    state.UnReadNotificationCount = data.data.filter(n => n.read_at == null).length
}

export function setNotificationsLoading(state, loading) {
    state.notifications.loading = loading
}

export function setDashboard(state, data) {
    state.dashboard = {
        ...state.dashboard,
        ...data,
        loading: false,
    }
}

export function setDashboardLoading(state, loading) {
    state.dashboard.loading = loading
}

export function setVideos(state, data) {
    state.videos = data
}

export function setActiveReviews(state, data) {
    if (data) {
        state.activeReviews = {
            ...state.activeReviews,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
            loading: false
        }
    }
}

export function setGalleries(state, data) {
    if (data) {
        state.galleries = {
            ...state.galleries,
            data: data.data,
            links: data.meta?.links,
            page: data.meta.current_page,
            limit: data.meta.per_page,
            from: data.meta.from,
            to: data.meta.to,
            total: data.meta.total,
            loading: false
        }
    }
}

export function setUsersImages(state, data) {
    state.usersImages = data
    state.usersImages.loading = false
}

export function setUnReadNotificationCount(state, count) {
    state.UnReadNotificationCount = count
}
